import { BRT_OFFSET_MS, brasiliaDate } from './period';

/** Affiliate payments are monthly, by the Brazilian calendar: a month starts at 00:00 in Brasília. */
const DAY_MS = 86_400_000;

/** A month closes this long after it ends: Deriv confirms each day about 26h after it closed. */
export const PAYOUT_MONTH_CLOSE_DELAY_MS = 2 * DAY_MS;

export const PAYOUT_MONTH_RE = /^(\d{4})-(0[1-9]|1[0-2])$/;

/** 'YYYY-MM' of the Brasília month an instant falls in. */
export function payoutMonthOf(at: Date): string {
  return new Date(at.getTime() - BRT_OFFSET_MS).toISOString().slice(0, 7);
}

/** The instants [start, end) of a Brasília month, and when it closes for payment. */
export function payoutMonthRange(month: string): { start: Date; end: Date; closesAt: Date; firstDay: string; lastDay: string } {
  const m = PAYOUT_MONTH_RE.exec(month);
  if (!m) throw new Error(`Invalid month: ${month}`);
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const start = new Date(Date.UTC(y, mo, 1) + BRT_OFFSET_MS);
  const end = new Date(Date.UTC(y, mo + 1, 1) + BRT_OFFSET_MS);
  return {
    start,
    end,
    closesAt: new Date(end.getTime() + PAYOUT_MONTH_CLOSE_DELAY_MS),
    firstDay: `${month}-01`,
    lastDay: new Date(Date.UTC(y, mo + 1, 0)).toISOString().slice(0, 10),
  };
}

/** The month `n` months after `month` (negative: before). */
export function shiftPayoutMonth(month: string, n: number): string {
  const m = PAYOUT_MONTH_RE.exec(month);
  if (!m) throw new Error(`Invalid month: ${month}`);
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1 + n, 1)).toISOString().slice(0, 7);
}

/** Today's date ('YYYY-MM-DD') in Brasília. */
export function brasiliaToday(now = new Date()): string {
  return brasiliaDate(now);
}
